<template>
  <div class="home">
    <div class="overlay"></div>
    <div class="container">
      <div class="content">
        <h1 class="title">{{ title }}</h1>
        <p class="description">{{ description }}</p>
        <a-button type="primary" class="learn-more" @click="handleEnter">
          Enter Now
          <template #icon><right-outlined /></template>
        </a-button>
      </div>
      <div class="album-container">
        <div class="album">
          <div v-for="(image, index) in images" :key="index" 
               class="album-item"
               :style="getTransform(index)">
            <img :src="image" :alt="'Image ' + (index + 1)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { RightOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'Home',
  components: {
    RightOutlined
  },
  setup() {
    const router = useRouter()
    const title = ref('欢迎来到天际套图')
    const description = ref('还在为找不到人设发愁？还在为怕找到本人发愁？还在为没素材发愁？还在为因人设死号发愁？我们有ig素材扩展图，有新人物套图，高端定制图，手工素描图等。请敬请挑选！')

    // 示例图片数组，需要替换为实际的图片路径
    const images = ref([
      require('@/assets/1.jpg'),
      require('@/assets/2.jpg'),
      require('@/assets/3.jpg'),
      require('@/assets/4.jpg'),
      require('@/assets/5.jpg'),
      require('@/assets/6.jpg'),
    ])

    const handleEnter = () => {
      router.push('/main')
    }

    const getTransform = (index) => {
      const transforms = [
        'rotateY(0deg) translateZ(150px)',          // front
        'rotateY(90deg) translateZ(150px)',         // right
        'rotateY(180deg) translateZ(150px)',        // back
        'rotateY(270deg) translateZ(150px)',        // left
        'rotateX(90deg) translateZ(150px)',         // top
        'rotateX(-90deg) translateZ(150px)',        // bottom
      ]
      return {
        transform: transforms[index]
      }
    }

    return {
      title,
      description,
      handleEnter,
      images,
      getTransform
    }
  }
})
</script>

<style scoped>
.home {
  height: 100vh;
  width: 100%;
  background-image: url('../assets/space-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  color: white;
  position: relative;
  overflow: hidden;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.container {
  display: flex;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  padding: 0 2rem;
}

.content {
  flex: 1;
  text-align: left;
  padding: 2rem;
  max-width: 600px;
}

.title {
  font-size: 4rem;
  margin-bottom: 1.5rem;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.description {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.learn-more {
  font-size: 1.2rem;
  height: auto;
  padding: 0.8rem 2rem;
}

.album-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000px;
  height: 400px;
}

.album {
  position: relative;
  width: 300px;
  height: 300px;
  transform-style: preserve-3d;
  animation: rotate 20s infinite linear;
}

.album-item {
  position: absolute;
  width: 300px;
  height: 300px;
  backface-visibility: hidden;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.album-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes rotate {
  0% {
    transform: rotateY(0deg) rotateX(0deg);
  }
  50% {
    transform: rotateY(180deg) rotateX(180deg);
  }
  100% {
    transform: rotateY(360deg) rotateX(360deg);
  }
}
</style> 